import qs from 'qs';

/**
 * Утилита для обогащения ссылки query-параметрами
 * */
export const enrichOfferLinkWithParams = (link: string, params: Record<string, string>): string => {
  const stringifiedParams = qs.stringify(params);
  if (link.includes('?')) {
    return `${link}&${stringifiedParams}`;
  } else {
    return `${link}?${stringifiedParams}`;
  }
};
